import React from 'react';
import { Link } from 'react-router-dom';
import './AboutBanner.scss';
import bannerOne from '../../assets/about/banner/banner_1.png'
import bannerTwo from '../../assets/about/banner/banner_2.png'
import pattern from '../../assets/banner/pattern.png'

const AboutBanner = () => {
    return (
        <section className='about-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="about-banner-text">
                                    <h2>Voorstellen</h2>
                                    <p>Ik heb in 2008 mijn studie tandheelkunde in India afgerond. Sinds 2016 ben ik als tandarts in Nederland werkzaam. Voor mij is communicatie erg belangrijk om goed te begrijpen wat de problemen van de patiënt zijn en om een goed behandelplan voor de patiënt op te stellen.</p>
<p>Ik heb veel cursussen m.b.t. kindertandheelkunde gevolgd en op dit moment volg ik een Master opleiding in Engeland m.b.t. restauratieve en esthetische tandheelkunde. Ik vind het belangrijk om regelmatig opleidingen en cursussen zowel in Nederland als daarbuiten te volgen omdat ik op die manier mijn patiënten beter kan (blijven) helpen.</p>
<p>Ik ben van mening dat preventie altijd de sleutel is om grote problemen te voorkomen en ik ben altijd blij als ik tijdens mijn controles bij mijn patiënten meer over preventieve maatregelen kan vertellen.</p>
<p>Mijn interesse gaat uit naar kindertandheelkunde, restauratieve en esthetische tandheelkunde. Daarnaast heb ik veel ervaring met het behandelen van angstige patiënten.</p>
<p>Mijn doel is om altijd te blijven leren en patiënten zo goed mogelijk te helpen.</p>

                                    <div className="theme-btn">
                                        <Link to='/'>Contact</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="about-banner-img">
                                    <img src={bannerOne} alt="about banner"/>
                                    <img src={bannerTwo} alt="about banner two"/>
                                    <img className='pattern' src={pattern} alt="about banner two"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutBanner;